export default __webpack_public_path__ + "static/media/ttmikbooks_04.19f7e10d.jpg";